var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", { staticClass: "m-2 translations" }, [
    _c("table", { staticClass: "w-100" }, [
      _c(
        "tbody",
        _vm._l(_vm.translations.entries(), function([i, kv]) {
          return _c("tr", [
            _c("td", { staticClass: "pb-1" }, [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: kv[0],
                    expression: "kv[0]"
                  }
                ],
                staticClass: "form-control",
                attrs: { type: "text" },
                domProps: { value: kv[0] },
                on: {
                  input: function($event) {
                    if ($event.target.composing) return
                    _vm.$set(kv, 0, $event.target.value)
                  }
                }
              })
            ]),
            _vm._v(" "),
            _c("td", { staticClass: "pb-1 pl-1" }, [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: kv[1],
                    expression: "kv[1]"
                  }
                ],
                staticClass: "form-control",
                attrs: { type: "text" },
                domProps: { value: kv[1] },
                on: {
                  input: function($event) {
                    if ($event.target.composing) return
                    _vm.$set(kv, 1, $event.target.value)
                  }
                }
              })
            ]),
            _vm._v(" "),
            _c("td", { staticClass: "pb-1 pl-1" }, [
              _c(
                "button",
                {
                  staticClass: "btn btn-danger",
                  on: {
                    click: function($event) {
                      return _vm.translations.splice(i, 1)
                    }
                  }
                },
                [_c("i", { staticClass: "fa fa-dumpster" })]
              )
            ])
          ])
        }),
        0
      )
    ]),
    _vm._v(" "),
    _c(
      "button",
      {
        staticClass: "btn btn-success",
        on: {
          click: function($event) {
            return _vm.translations.push(["", ""])
          }
        }
      },
      [_c("i", { staticClass: "fa fa-plus" })]
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }